<template>
  <div class="koc-block koc-auth-login-register-block">
    <div
      v-if="state.user"
      class="koc-full"
    >
      <h3>You are currently logged in as {{ state.user.displayName }}</h3>
    </div>
    <div
      v-else
      class="koc-full"
    >
      <div class="koc-tabs koc-header-with-tabs">
        <span
          class="koc-button koc-ripple koc-capitalize"
          :class="{ active: 'register' === state.active }"
          @click="state.active = 'register'"
        >Create Account</span>
        <span
          class="koc-button koc-ripple koc-capitalize"
          :class="{ active: 'login' === state.active }"
          @click="state.active = 'login'"
        >Log In</span>
      </div>
      <div class="koc-inner">
        <div
          v-if="'register' === state.active"
          class="koc-block koc-register"
        >
          <auth-register-component
            @register="register"
            @login="state.active = 'login'"
          />
        </div>
        <div
          v-if="'login' === state.active"
          class="koc-block koc-login"
        >
          <auth-login-component @login="login" />
        </div>
      </div>
    </div>
  </div>
</template>

<script src="./login-register.js"></script>
<style lang="scss" scoped src="./login-register.scss"></style>
